import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type RulesetConfig = typeof RulesetConfig._.Config;

export const RulesetConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.Ruleset,
  configSchema: z.object({
    rulesetId: z.number().positive(),
    repoName: z.string().optional(),
  }),
});
